import { clearLegacyAuthTokens } from './legacyAuthCleanup';

export function clearClientAuthStorage() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  clearLegacyAuthTokens();
}

/** Full document load so Redux and route state reset. */
export function redirectToPublicHome() {
  if (typeof window === 'undefined') return;
  window.location.assign(`${window.location.origin}/`);
}
